import useInfiniteFetch from '@hooks/useInfiniteFetch';
import { getCMSHost } from '@utils/api-helper/host';
import { unstable_serialize } from 'swr/infinite';

const defaultCMSHost = getCMSHost();

const useSinglePlaylists = (
  goalUID,
  options = { fallbackData: undefined, revalidateOnMount: false }
) => {
  const key = `${defaultCMSHost}api/youtube-playlist-courses/getSingleVideoPlaylists/${goalUID}?limit=8&offset=0`;

  const { data: singlePlaylists, ...rest } = useInfiniteFetch(
    key,
    { applyOffsetsAutomatically: false },
    {
      fallbackData: options.fallbackData ? [options.fallbackData] : undefined,
      revalidateOnMount: options.revalidateOnMount,
      revalidateFirstPage: false
    }
  );

  return {
    singlePlaylists,
    ...rest,
    key: unstable_serialize(() => key)
  };
};

export default useSinglePlaylists;
